import { colors } from "../../styles/style";

const styleModalComponent = {
  titlesModalContainer: {
    padding: 10,
    marginBottom: 10,
  },
  colsContainer: {
    alignSelf: "center",
    alignContent: "center",
    textAlign: "center",
  },
  colsComents: {
    alignSelf: "center",
    alignContent: "center",
    textAlign: "center",
    padding:"15px"
  },
  textContainer: {
    padding: 10,
    border: "1px solid " + colors.GRAY_5_COLOR,
    borderRadius: 10,
    marginBottom: 10,
  },
};

export { styleModalComponent };
